<template>
<div class="app has-header">
    <div class="header">
        <menutabs :state="{tabs: tabs}" :tab-selected="tabSelected" @tab-select="UpdateSelectedView"></menutabs>
        
    </div>
    <component ref="component" :is="tabSelected.view"/>
</div>
</template>

<script>
import employeedata from './employeedata/EmployeeData.vue'
import employeetypeoverviewtable from '../plancontext/EmployeeTypeOverviewTable.vue'
import employeerulesoverviewtable from '../plancontext/EmployeeRulesOverviewTable.vue'
import storebannernotificationoverview from './bannermessage/StoreBannerNotificationOverview'
import skillsoverview from './skills/SkillsOverview'
import { mapState, mapGetters } from 'vuex';
export default {
    components: {
        employeerulesoverviewtable,
        employeedata,
        employeetypeoverviewtable,
        storebannernotificationoverview,
        skillsoverview
    },
    name: 'EmployeesMain',
    data() {
        return {
            viewMode: 1, 
            loading: true,
            employeeIdToSelect: null,
            tabSelected: null,
        }
    },
    watch: {},
    props: {
        view: String,
        selectedEmployeeId: String
    },
    created() {
        window.employeesettings = this;
        this.employeeIdToSelect = this.selectedEmployeeId;
        var settings = this;
        let view = this;
        if(this.$router.currentRoute.params.tab){
            let tab = this.tabs.find(t => t.view === view.$router.currentRoute.params.tab);
            if(tab){
                this.tabSelected = tab;
            }
        } else {
            let tab = this.tabs.find(t => t.selected);
            if(tab) this.tabSelected = tab;
            else this.tabSelected = {view: this.view ? this.view : 'employeedata'};
        }
    },
    mounted(){   
    },
    computed: {
        ...mapGetters(['storeId', 'isSuperUser', 'storeSettings']),
        tabs() {
            let tabs = [{label: this.$t('pages.employeeContext.coreData'), view: 'employeedata', selected: true, margin: true}];
            tabs.push({label: this.$t('pages.employeeContext.skills'), view: 'skillsoverview', margin: true});
            if(this.storeSettings && !this.storeSettings.simpleMode){
                
                tabs.push({label: this.$tc('pages.employeeContext.planning', 0), view: 'employeetypeoverviewtable', margin: true});
                tabs.push({label: this.$t('pages.employeeContext.recreation'), view: 'employeerulesoverviewtable', margin: true});
                tabs.push({label: this.$t('pages.employeeContext.appInfo'), view: 'storebannernotificationoverview', margin: true});
               

              

            }   
            return tabs;
           
        }
    },
    updated() {},
    destroyed() {},
    methods: {
        UpdateSelectedView(tab){
            this.tabs.forEach(t => t.selected = false);
            tab.selected = true;
            this.tabSelected = tab;
        }
        
    }
}
</script>
